export const SITE_TYPES = [
  'construction_site',
  'disposal',
  'factory',
  'plant',
  'warehouse',
] as const;
